import React, { Component } from 'react'
import Template from '../interfaz/Template';
import { connect } from 'react-redux'
import AuthenticatedComponent from '../../componentes/AuthenticatedComponent'
import sinCompulsa from '../../img/compulsa_en_proceso.png'

let msjError = "";

export class SinResultadoCompulsa extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cargado: true
        }
    }

    funcionListo = () => {
    }

    render() {
        return (
            <AuthenticatedComponent listo={this.funcionListo}>
                <Template contenido={
                    <React.Fragment>
                        <center>
                            <img src={sinCompulsa} alt="Sin resultado de compulsa" width="50%" height="40%" style={{marginBottom:'50px'}} />
                        </center>
                    </React.Fragment>
                }
                    bloqueado={!this.state.cargado}
                />
            </AuthenticatedComponent>
        )
    }
}

const mapStateToProps = state => {
    var datosAspirante;
    var datosUsuario;

    if (state.user.datosAspirante)
        datosAspirante = state.user.datosAspirante;
    datosUsuario = state.user.currentUser;


    return {
        datosAspirante: datosAspirante,
        datosUsuario: datosUsuario,
    };
}

export default (connect(mapStateToProps)(SinResultadoCompulsa));
